import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-lead',
  templateUrl: './lead.component.html',
  styleUrls: ['./lead.component.scss']
})
export class LeadComponent implements OnInit {

  @Input() backgroundImageUrl: string = '/assets/img/content/about/lead.jpg'

  constructor() { }

  ngOnInit() {
  }

}
